import React, { Fragment } from 'react';
import {
    DataGrid,
    DataGridToolbar,
    DataGridToolbarButtonsGroup,
    DataGridToolbarErrorsButton,
    DataGridToolbarCheckBox,
    DataGridToolbarSplitButton,
    DataGridToolbarDropdownButton,
    DataGridToolbarDropdownItem,
    DataGridToolbarButtonSave,
    DataGridToolbarButtonDiscard,
    DataGridToolbarButtonRefresh,
    DataGridToolbarButtonImport,
    DataGridToolbarButtonEdit,
    DataGridToolbarButtonHistory,
    DataGridToolbarFavoritesSplitButton
} from '../BaseComponents';
import AppStatusEdit from './AppStatusEdit';
import DuPont from '../../jscomponents/DuPontApp';

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';
import ProjectRequired from '../BaseComponents/ProjectRequired';

let properties;

const Toolbar = () => {

    const { tempCurrentSpin, crossSpinDataHidden, multiSpin } = DuPont.App.Config;
    var currentSpin = multiSpin ? properties.match.params.project : tempCurrentSpin;
    currentSpin = currentSpin.toUpperCase();
    console.log(`currentSpin: ${currentSpin}`);

    return (
        <DataGridToolbar
            title={currentSpin + " App Status"}
        >
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarErrorsButton />
                <DataGridToolbarButtonSave />
                <DataGridToolbarButtonDiscard />
            </DataGridToolbarButtonsGroup>{' '}
            <DataGridToolbarCheckBox
                id="showAllCheckBox"
                filterOrder="2"
                filterWhenChecked="all"
                filterWhenUnchecked="enabled"
                caption="Show Disabled Apps"
            />
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarDropdownButton
                    caption="Choose filter"
                    glyph="filter"
                    glyphColor='#4189C7'
                    filterOrder="1"
                    filterReqMsg="Please choose a filter!"
                >
                    {

                        <Fragment>
                            <DataGridToolbarDropdownItem dynModel="appStatusSaaS" filter={"SaaS/" + currentSpin} href="#">SaaS</DataGridToolbarDropdownItem>
                            <DataGridToolbarDropdownItem dynModel="appStatusNonSaaS" filter={"NonSaaS/" + currentSpin} href="#">Non SaaS</DataGridToolbarDropdownItem>
                        </Fragment>
                    }
                </DataGridToolbarDropdownButton>{' '}
                <DataGridToolbarButtonRefresh />
                <DataGridToolbarButtonImport />
                {/*<DataGridToolbarButtonExport />*/}
                <DataGridToolbarSplitButton
                    bsStyle="info"
                    text="Export"
                    tooltip
                    btnClass="btn-export"
                    glyph="download"
                    glyphColor='#4189C7'
                    modalTarget="#downloadModal"
                    filterReq="1"
                >
                    <DataGridToolbarDropdownItem
                        btnClass="btn-export-track-changes"
                        modalTarget="#downloadModal"
                        filterReq="1"
                        caption="Export with TrackChanges"
                    />
                    <DataGridToolbarDropdownItem
                        btnClass="btn-export-all"
                        modalTarget="#downloadModal"
                        exportUrl={`/api/ApplicationStatus/export/all/${currentSpin || 'all'}/enabled`}
                        caption="Export ALL"
                    />
                    {/*
                    <DataGridToolbarDropdownItem
                        btnClass="btn-export-transposed"
                        modalTarget="#downloadModal"
                        exportExtrapath="transposed"
                        caption="Export for MPP"
                    />
                    */}
                </DataGridToolbarSplitButton>
                <DataGridToolbarButtonEdit text="Edit Notes" />
                <DataGridToolbarButtonHistory />
                <DataGridToolbarFavoritesSplitButton />
            </DataGridToolbarButtonsGroup>
        </DataGridToolbar>
    );
};

const AppStatus = props => {

    const { multiSpin } = DuPont.App.Config;

    if (multiSpin && !props.match.params.project) {
        return (
            <ProjectRequired /> 
        );
    }

    properties = props;

    console.log('appstatus; Props', props);

    return (
        <DataGrid model='appStatus'>
            <AppStatusEdit />
            <Toolbar />
        </DataGrid>
    );
};

export default withAITracking(ai.reactPlugin, AppStatus, "AppStatus");